import { defineMessages } from "@formatjs/intl";

export const messages = defineMessages({
  G7_P1_Title: {
    id: `guide07.page01.title`,
  },
  //List1
  G7_P1_G1_Title: {
    id: `guide07.page01.group1.title`,
  },
  G7_P1_G1_I1_Title: {
    id: `guide07.page01.group1.item1.title`,
  },
  G7_P1_G1_I1_Link: {
    id: `guide07.page01.group1.item1.link`,
  },
  //List2
  G7_P1_G2_Title: {
    id: `guide07.page01.group2.title`,
  },
  G7_P1_G2_I1_Title: {
    id: `guide07.page01.group2.item1.title`,
  },
  G7_P1_G2_I1_Link: {
    id: `guide07.page01.group2.item1.link`,
  },
  G7_P1_G2_I2_Title: {
    id: `guide07.page01.group2.item2.title`,
  },
  G7_P1_G2_I2_Link: {
    id: `guide07.page01.group2.item2.link`,
  },
  G7_P1_G2_I3_Title: {
    id: `guide07.page01.group2.item3.title`,
  },
  G7_P1_G2_I3_Link: {
    id: `guide07.page01.group2.item3.link`,
  },
  G7_P1_G2_I4_Title: {
    id: `guide07.page01.group2.item4.title`,
  },
  G7_P1_G2_I4_Link: {
    id: `guide07.page01.group2.item4.link`,
  },
  G7_P1_G2_I5_Title: {
    id: `guide07.page01.group2.item5.title`,
  },
  G7_P1_G2_I5_Link: {
    id: `guide07.page01.group2.item5.link`,
  },
  G7_P1_G2_I6_Title: {
    id: `guide07.page01.group2.item6.title`,
  },
  G7_P1_G2_I6_Link: {
    id: `guide07.page01.group2.item6.link`,
  },
  G7_P1_G2_I7_Title: {
    id: `guide07.page01.group2.item7.title`,
  },
  G7_P1_G2_I7_Link: {
    id: `guide07.page01.group2.item7.link`,
  },
  G7_P1_G2_I8_Title: {
    id: `guide07.page01.group2.item8.title`,
  },
  G7_P1_G2_I8_Link: {
    id: `guide07.page01.group2.item8.link`,
  },
  G7_P1_Note: {
    id: `guide07.page01.note`,
  },

  // Page 2
  G7_P2_Title: {
    id: `guide07.page02.title`,
  },
  //List1
  G7_P2_G1_Title: {
    id: `guide07.page02.group1.title`,
  },
  G7_P2_G1_I1_Title: {
    id: `guide07.page02.group1.item1.title`,
  },
  G7_P2_G1_I1_Comment: {
    id: `guide07.page02.group1.item1.comment`,
  },
  G7_P2_G1_I1_Link: {
    id: `guide07.page02.group1.item1.link`,
  },
  G7_P2_G1_I2_Title: {
    id: `guide07.page02.group1.item2.title`,
  },
  G7_P2_G1_I2_Link: {
    id: `guide07.page02.group1.item2.link`,
  },
  G7_P2_G1_I3_Title: {
    id: `guide07.page02.group1.item3.title`,
  },
  G7_P2_G1_I3_Link: {
    id: `guide07.page02.group1.item3.link`,
  },
  G7_P2_Note: {
    id: `guide07.page02.note`,
  },

  // Page 3
  G7_P3_Title: {
    id: `guide07.page03.title`,
  },
  //List1
  G7_P3_G1_Title: {
    id: `guide07.page03.group1.title`,
  },
  G7_P3_G1_I1_Title: {
    id: `guide07.page03.group1.item1.title`,
  },
  G7_P3_G1_I1_Link: {
    id: `guide07.page03.group1.item1.link`,
  },
  G7_P3_G1_I2_Title: {
    id: `guide07.page03.group1.item2.title`,
  },
  G7_P3_G1_I2_Link: {
    id: `guide07.page03.group1.item2.link`,
  },
  G7_P3_G1_I3_Title: {
    id: `guide07.page03.group1.item3.title`,
  },
  G7_P3_G1_I3_Link: {
    id: `guide07.page03.group1.item3.link`,
  },
  G7_P3_G1_I4_Title: {
    id: `guide07.page03.group1.item4.title`,
  },
  G7_P3_G1_I4_Link: {
    id: `guide07.page03.group1.item4.link`,
  },
  G7_P3_G1_I5_Title: {
    id: `guide07.page03.group1.item5.title`,
  },
  G7_P3_G1_I5_Link: {
    id: `guide07.page03.group1.item5.link`,
  },
  G7_P3_G1_I6_Title: {
    id: `guide07.page03.group1.item6.title`,
  },
  G7_P3_G1_I6_Link: {
    id: `guide07.page03.group1.item6.link`,
  },
  G7_P3_G1_I7_Title: {
    id: `guide07.page03.group1.item7.title`,
  },
  G7_P3_G1_I7_Link: {
    id: `guide07.page03.group1.item7.link`,
  },
  G7_P3_Note: {
    id: `guide07.page03.note`,
  },

  // Page 4
  G7_P4_Title: {
    id: `guide07.page04.title`,
  },
  //List1
  G7_P4_G1_Title: {
    id: `guide07.page04.group1.title`,
  },
  G7_P4_G1_I1_Title: {
    id: `guide07.page04.group1.item1.title`,
  },
  G7_P4_G1_I1_Link: {
    id: `guide07.page04.group1.item1.link`,
  },
  G7_P4_G1_I2_Title: {
    id: `guide07.page04.group1.item2.title`,
  },
  G7_P4_G1_I2_Link: {
    id: `guide07.page04.group1.item2.link`,
  },
  G7_P4_G1_I3_Title: {
    id: `guide07.page04.group1.item3.title`,
  },
  G7_P4_G1_I3_Link: {
    id: `guide07.page04.group1.item3.link`,
  },
  G7_P4_Note: {
    id: `guide07.page04.note`,
  },

  // Page 5
  G7_P5_Title: {
    id: `guide07.page05.title`,
  },
  //List1
  G7_P5_G1_Title: {
    id: `guide07.page05.group1.title`,
  },
  G7_P5_G1_I1_Title: {
    id: `guide07.page05.group1.item1.title`,
  },
  G7_P5_G1_I1_Link: {
    id: `guide07.page05.group1.item1.link`,
  },
  G7_P5_Note: {
    id: `guide07.page05.note`,
  },

  // Page 6
  G7_P6_Title: {
    id: `guide07.page06.title`,
  },
  //List1
  G7_P6_G1_Title: {
    id: `guide07.page06.group1.title`,
  },
  G7_P6_G1_I1_Title: {
    id: `guide07.page06.group1.item1.title`,
  },
  G7_P6_G1_I1_Link: {
    id: `guide07.page06.group1.item1.link`,
  },
  G7_P6_Note: {
    id: `guide07.page06.note`,
  },
});
